import { render, staticRenderFns } from "./RegistrationConfirmationDialog.vue?vue&type=template&id=43a35b6f&scoped=true&"
import script from "./RegistrationConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirmationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a35b6f",
  null
  
)

export default component.exports